import _ from 'lodash';

import { stripVersion } from '@zapier/common-utils/src/services';

import {
  getClassName,
  getDataSet,
  getHref,
  getPath,
  getText,
  parseInlineStyleURL,
  selectAll,
  selectFirst,
  selectLast,
  transformDataSet,
  transformServiceTypes,
} from 'app/zapbook/domUtils';

const transformServiceNodes = nodeArray =>
  _.map(nodeArray, listEl => {
    const maybeTagClass = getClassName(selectFirst('a > span.tag', listEl));
    const hasTag = Boolean(maybeTagClass);
    const icon =
      hasTag &&
      (maybeTagClass.match('upcoming') || maybeTagClass.match('early-access'))
        ? parseInlineStyleURL(selectFirst('div.app-logo', listEl))
        : getClassName(selectFirst('div.app-logo', listEl));
    return {
      hasTag,
      icon,
      tagClass: maybeTagClass ? maybeTagClass.replace('tag ', '').trim() : null,
      service: getText(selectFirst('a > .app-name', listEl)),
      className: stripVersion(getClassName(listEl)),
      serviceTypes: transformServiceTypes(getClassName(listEl)),
      dataset: transformDataSet(getDataSet(listEl)),
      path: getPath(selectFirst('a', listEl)),
    };
  });

const transformCategories = categories =>
  _.map(categories, category => ({
    dataset: transformDataSet(getDataSet(category)),
    category: getText(category),
  }));

const transformRequestAddUpdates = nodeArray => {
  const [request, add, updates] = nodeArray.map(node => {
    return {
      heading: getText(selectFirst('h3', node)),
      content: getText(selectFirst('p', node)),
      link: {
        href: getHref(selectLast('p > a', node)),
        text: getText(selectLast('p > a', node)),
      },
    };
  });
  return { request, add, updates };
};

export const mapDocumentToAppPickerProps = initialContainerElement => ({
  services: transformServiceNodes(
    selectAll('.service.app-picker-item', initialContainerElement)
  ).map((service, i) => ({ ...service, id: i, isActive: true })),
  sortCategories: transformCategories(
    selectAll(
      `.apps-categories-list [data-service-sort]:not(.sorter)`,
      initialContainerElement
    )
  ),
  filterCategories: transformCategories(
    selectAll(
      `.apps-categories-list [data-service-filter]`,
      initialContainerElement
    )
  ),
  requestAddUpdates: transformRequestAddUpdates(
    selectAll('.mobile-hide', initialContainerElement).slice(1)
  ),
});
